import { Variable, VariableClass, Div, Span } from 'alkali'

export const Loading = Variable() as VariableClass<boolean, boolean>

export class Loader extends Div(
	'.loader',
	{
		display: Loading,
	},
	[Span('.fa.fa-spin.fa-2x.fa-spinner', { title: 'Loading...' })]
) {
	static readonly Loading = Loading
	created(props) {
		if (props.loading) {
			props.display = props.loading
		}
	}
}

export default Loader
